/* Shared by the cart-threshold and BXGY promotions. No storefront dependencies. */
(function (root, factory) {
  var utils = factory();
  if (typeof module === 'object' && module.exports) module.exports = utils;
  else root.CartGiftUtils = utils;
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';

  function parseSchedule(value) {
    var match = typeof value === 'string' && value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!match) return null;
    var parts = match.slice(1).map(Number);
    var date = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4]));
    if (date.getUTCFullYear() !== parts[0] || date.getUTCMonth() + 1 !== parts[1] ||
        date.getUTCDate() !== parts[2] || date.getUTCHours() !== parts[3] || date.getUTCMinutes() !== parts[4]) return null;
    return Number(match.slice(1).join(''));
  }

  function createSchedule(start, end, timeZone) {
    var startKey = parseSchedule(start);
    var endKey = parseSchedule(end);
    var formatter;
    try {
      if (!timeZone || !startKey || !endKey || endKey <= startKey) throw new Error('Invalid schedule');
      formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone.trim(), year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      });
    } catch (_) {
      return { state: function () { return { active: false, future: false }; } };
    }
    return {
      state: function (date) {
        var parts = {};
        formatter.formatToParts(date || new Date()).forEach(function (part) { parts[part.type] = part.value; });
        var key = Number(parts.year + parts.month + parts.day + parts.hour + parts.minute);
        return { active: key >= startKey && key < endKey, future: key < endKey };
      }
    };
  }

  function isGift(item) {
    var properties = item.properties || {};
    return properties._cart_threshold_gift === 'true' || properties._bxgy_free_gift === 'true';
  }

  // Line keys can change when discounts change. Keep the customer's choice tied
  // to the gift variant and promotion instead.
  function giftIdentity(item) {
    var properties = item.properties || {};
    var variant = item.variant_id || item.id;
    if (properties._cart_threshold_gift === 'true') return 'threshold:' + variant;
    if (properties._bxgy_free_gift === 'true') return 'bxgy:' + properties._bxgy_offer_id + ':' + variant;
    return '';
  }

  function removalCandidates(cart, type, data) {
    if (!cart || (type !== 'change' && type !== 'update')) return [];
    if (typeof data === 'string') {
      try { data = JSON.parse(data); }
      catch (_) { data = new URLSearchParams(data); }
    }
    if (data && typeof data.entries === 'function') {
      var parsed = {};
      for (var entry of data.entries()) {
        var match = entry[0].match(/^updates\[(.*)\]$/);
        if (match) {
          if (!parsed.updates) parsed.updates = match[1] ? {} : [];
          if (match[1]) parsed.updates[match[1]] = entry[1];
          else parsed.updates.push(entry[1]);
        } else parsed[entry[0]] = entry[1];
      }
      data = parsed;
    }
    if (!data) return [];
    var items = cart.items || [];
    var removed = [];
    function remove(item, quantity) {
      if (item && (quantity === 0 || quantity === '0') && isGift(item)) removed.push(item);
    }
    function find(id) {
      return items.find(function (item) { return item.key === String(id) || String(item.variant_id) === String(id); });
    }
    if (type === 'change') remove(data.id != null ? find(data.id) : items[Number(data.line) - 1], data.quantity);
    else if (Array.isArray(data.updates)) data.updates.forEach(function (quantity, index) { remove(items[index], quantity); });
    else if (data.updates && typeof data.updates === 'object') Object.keys(data.updates).forEach(function (id) {
      remove(find(id), data.updates[id]);
    });
    return removed;
  }

  function fingerprint(cart) {
    return JSON.stringify([cart.currency, cart.total_price, cart.items.map(function (item) {
      return [item.key, item.quantity, item.final_line_price];
    })]);
  }

  // total_price includes both product and order discounts. items_subtotal_price does not.
  // Free gift lines contribute zero. For a misconfigured, paid gift, subtract its full
  // line contribution conservatively until it can be removed; it must never unlock itself.
  function qualifyingTotal(cart) {
    if (!Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return 0;
    return Math.max(0, cart.total_price - cart.items.filter(isGift).reduce(function (sum, item) {
      return sum + Math.max(0, Number(item.final_line_price) || 0);
    }, 0));
  }

  return {
    createSchedule: createSchedule, isGift: isGift, fingerprint: fingerprint, qualifyingTotal: qualifyingTotal,
    giftIdentity: giftIdentity, removalCandidates: removalCandidates
  };
});
